import { render } from "./DateWiseReport.vue?vue&type=template&id=3c2fb717&scoped=true"
import script from "./DateWiseReport.vue?vue&type=script&lang=js"
export * from "./DateWiseReport.vue?vue&type=script&lang=js"

import "./DateWiseReport.vue?vue&type=style&index=0&id=3c2fb717&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2fb717"]])

export default __exports__